import { AxiosRequestConfig } from 'axios';
import { SessionStorageEnum } from '../enum/SessionStorageEnum';
import { MenuUrlEnum } from 'src/components/common/side-menu/MenuUrlEnum';
import { History } from 'history';

export const AuthorizationInterceptor = (history: History<any>) => async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
  try {
    if (history.location.pathname === MenuUrlEnum.Login) {
      return config
    }

    const sessionToken = sessionStorage.getItem(SessionStorageEnum.session)
    if (sessionToken) {
      config.headers.Session = sessionToken
    }
  } catch (error) {
    console.error(error)
  }

  return config
};
